// /pages/PublicViewerImages.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const PublicViewerImages = () => {
  const { publicId  } = useParams();
  const [examen, setExamen] = useState(null);
  const [images, setImages] = useState([]);

  const calculerAge = (dateNaissance) => {
  if (!dateNaissance) return "—";
  const naissance = new Date(dateNaissance);
  const maintenant = new Date();
  let age = maintenant.getFullYear() - naissance.getFullYear();
  const mois = maintenant.getMonth() - naissance.getMonth();
  if (mois < 0 || (mois === 0 && maintenant.getDate() < naissance.getDate())) {
    age--;
  }
  return age + " ans";
};


  useEffect(() => {
    if (!publicId ) return;

    axios
      .get(`${process.env.REACT_APP_EUREKA_PACS_URL}/api/public/examen/${publicId }/images`)
      .then((res) => {
        setExamen(res.data);
        setImages(res.data.images || []);
      })
      .catch((err) => console.error("Erreur fetch images :", err));
  }, [publicId ]);

  if (!examen) {
    return (
      <div
        style={{
          background: "#1e1e1e",
          color: "#fff",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "18px",
        }}
      >
        Chargement de l’examen...
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div
        style={{
          background: "#1e1e1e",
          color: "#fff",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "18px",
        }}
      >
        Aucune image disponible pour cet examen.
      </div>
    );
  }

  // Préparation des images pour ImageGallery
  const items = images.map((url) => ({
    original: url,
    thumbnail: url,
    renderItem: () => (
      <Zoom>
        <img
          src={url}
          alt="Examen"
          style={{
            width: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
            background: "#111",
          }}
        />
      </Zoom>
    ),
  }));

  return (
    <div style={{ background: "#1e1e1e", minHeight: "100vh", color: "#fff" }}>
      {/* ====== HEADER ====== */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px",
          borderBottom: "2px solid #6c63ff",
        }}
      >
      

        <h1 style={{ color: "#e4e4e4ff", fontSize: "20px", margin: 0 }}>
          Eureka Pacs
        </h1>
      </header>

      {/* ====== INFOS PATIENT ====== */}
      <section style={{ padding: "20px" }}>
        <h2 style={{ color: "#6c63ff", marginBottom: "10px" }}>👤 Informations patient</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
            background: "#2c2c2c",
            padding: "15px",
            borderRadius: "8px",
            fontSize: "15px",
          }}
        >
          <div><strong>Nom :</strong> {examen.patientNom}</div>
          <div><strong>Prénom :</strong> {examen.patientPrenom}</div>
          <div><strong>Sexe :</strong> {examen.patientSexe}</div>
         <div>
  <strong>Âge :</strong>{" "}
  {examen.dateNaissance ? calculerAge(examen.dateNaissance) : "—"}
</div>
         
        </div>
      </section>

      {/* ====== GALERIE D’IMAGES ====== */}
      <section style={{ padding: "20px" }}>
        <h2 style={{ color: "#6c63ff", marginBottom: "10px" }}>🖼️ Images de l’examen</h2>
        <ImageGallery
          items={items}
          showPlayButton={false}
          showFullscreenButton={true}
          showIndex={true}
          slideInterval={5000}
          additionalClass="custom-gallery"
        />
      </section>
    </div>
  );
};

export default PublicViewerImages;
